import { render, staticRenderFns } from "./speech.vue?vue&type=template&id=6dce7393&scoped=true"
import script from "./speech.vue?vue&type=script&lang=js"
export * from "./speech.vue?vue&type=script&lang=js"
import style0 from "./speech.vue?vue&type=style&index=0&id=6dce7393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce7393",
  null
  
)

export default component.exports